import { render } from "./CommentaireListe.vue?vue&type=template&id=361d8b12"
import script from "./CommentaireListe.vue?vue&type=script&lang=js"
export * from "./CommentaireListe.vue?vue&type=script&lang=js"

import "./CommentaireListe.vue?vue&type=style&index=0&id=361d8b12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__